export const themeObj = {
  error: "#F04A4A",
  placeholder: "#ACACAC",
  textAreaColor: "#F1F1F1",
  violetColor: "#29252B",
  mainBg: "#E9E3D5",
  buttonColor: "#F6C914",
  aboutCompany: "#272727",
};
